import type { TaxStatus } from '@/types/rebalance'

/**
 * Anzeige-Labels für den Steuer-Status einer Rebalance-Aktion.
 * Geteilt von ProposedActionItem (View) und exportRebalance (CSV).
 */
export const TAX_STATUS_LABEL: Record<TaxStatus, string> = {
  steuerfrei: 'FIFO > 2J: steuerfrei',
  voll_steuerpflichtig: 'Voll steuerpflichtig',
  teilweise: 'Teilweise steuerpflichtig',
  'n/a': '—',
}
